import { ref, markRaw } from 'vue'

export const mountedNodeRenderers = new Map()

export default class VueRenderer {
  constructor (component, {
    as = 'div',
    props,
    editor = undefined,
    nodeRendererName = 'default'
  }) {
    this.props = ref(props || {})
    this.component = markRaw(component)
    this.element = document.createElement(as)
    this.editor = editor || props.editor

    if (!mountedNodeRenderers.has(nodeRendererName)) {
      throw Error('No TipTapNodeRenderer found!')
    }
    this.nodeRenderer = mountedNodeRenderers.get(nodeRendererName)
    this.nodeRenderer.setupState.addVueRenderer(this)
  }

  get ref () {
    // This is the instance of the component,
    // you can call methods on the component from this
    return this.nodeRenderer.setupState.vueRendererRefs.get(this)
  }

  updateProps (props) {
    Object
      .entries(props)
      .forEach(([key, value]) => {
        this.props.value[key] = value
      })
  }

  destroy () {
    this.nodeRenderer.setupState.deleteVueRenderer(this)
  }
}
